function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import ImageWithPlaceholder from '@profile/src/Components/ImageWithPlaceHolder';
import styles from './styles.module.scss';
import { CosmeticRarity, CosmeticStatus, CosmeticType } from '@profile/src/utils/types';
import Spinner from '@profile/src/Components/Spinner';
import { formatParamPath, webImageUri } from '@profile/src/utils/uri';
import icSelling from '/assets/svg/ic_selling.svg';
import icSelected from '/assets/svg/ic_selected.svg';
import icProcessing from '/assets/svg/ic_processing.svg';
import { useTypedSelector } from '@profile/src/redux/utils';
import { useTestId } from '@wolffun/testable-id';
import { parseCosmeticType } from '@profile/src/Profile_V2/Components/History/CosmeticHistoryTab/utils';
const cosmeticRarityStyleMap = {
  [CosmeticRarity.COMMON]: styles.common,
  [CosmeticRarity.EPIC]: styles.epic,
  [CosmeticRarity.LEGENDARY]: styles.legendary
};
const ItemCard = /*#__PURE__*/React.forwardRef(({
  className,
  cosmetic,
  onPress
}, ref) => {
  const {
    generateTestIdProps
  } = useTestId();
  const {
    imgPathPattern
  } = useTypedSelector(state => state.cosmeticItemsConfigs);
  const cosmeticRarityClassName = cosmeticRarityStyleMap[cosmetic.cosmeticRarity];

  const renderStatus = (status, selected) => {
    if (selected) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.status
      }, /*#__PURE__*/React.createElement("img", {
        className: styles.img,
        src: icSelected
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.wrapText
      }, /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('cosmetic-status'), {
        className: styles.span
      }), "Selected")));
    }

    switch (status) {
      case CosmeticStatus.USER_NOT_MINT:
      case CosmeticStatus.NOT_MINT:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.lock
        }, /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('cosmetic-status'), {
          className: styles.span
        }), "NOT MINT"));

      case CosmeticStatus.SELLING:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.status
        }, /*#__PURE__*/React.createElement("img", {
          className: styles.img,
          src: icSelling
        }), /*#__PURE__*/React.createElement("div", {
          className: styles.wrapText
        }, /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('cosmetic-status'), {
          className: styles.span
        }), "Selling")));

      case CosmeticStatus.MINTING:
      case CosmeticStatus.PREPARE_SELLING:
      case CosmeticStatus.USER_MINTING:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.status
        }, /*#__PURE__*/React.createElement("img", {
          className: styles.img,
          src: icProcessing
        }), /*#__PURE__*/React.createElement("div", {
          className: styles.wrapText
        }, /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('cosmetic-status'), {
          className: styles.span
        }), "Processing")));

      default:
        return undefined;
    }
  };

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: classNames(className, styles.container),
    onClick: onPress
  }, generateTestIdProps('cosmetic-item')), /*#__PURE__*/React.createElement("div", {
    className: styles.bgCard
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.shape, styles.background)
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(ImageWithPlaceholder, _extends({}, generateTestIdProps('cosmetic-image'), {
    className: classNames(styles.portrait, cosmetic.cosmeticType !== CosmeticType.SPACESHIP && styles.smallPortrait),
    src: webImageUri(formatParamPath(imgPathPattern, {
      id: cosmetic.cosmeticInfo.typeId
    })),
    renderPlaceholder: () => /*#__PURE__*/React.createElement(Spinner, {
      secondary: true,
      size: "50%",
      className: classNames(styles.portrait, styles.spinner)
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.inner
  }, renderStatus(cosmetic.cosmeticInfo.status, cosmetic.isSelected), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.itemInfo, cosmeticRarityClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.wrapInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.line, cosmeticRarityClassName)
  }), /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('cosmetic-type'), {
    className: styles.name
  }), parseCosmeticType(cosmetic.cosmeticType)), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.tokenId, cosmeticRarityClassName)
  }, cosmetic.cosmeticName))))));
});
ItemCard.displayName = 'ItemCard';
export default ItemCard;